import { Fade, Grid, IconButton, Typography } from "@material-ui/core";

import Edit from "../../img/edit.svg";
import React from "react";
import { PagesUrl, utils } from "../../redux/General/generalActions";

import { useStyles } from "../../styles/mainStyles";

const PersonalInfo = ({ setEdit, profile, clear }) => {
  let border = useStyles();
  let { pages } = PagesUrl();
  let default_page = pages.find(
    (item) => item.value === profile.default_page_link
  );

  return (
    <Fade in={true} timeout={500}>
      <Grid
        item
        container
        justifyContent="center"
        xs={12}
        spacing={2}
        style={{ margin: "auto", height: "100%" }}
      >
        <Grid
          item
          xs={12}
          container
          justifyContent="space-between"
          alignItems="center"
          style={{ height: 50 }}
        >
          <Typography variant="body1">پروفایل من</Typography>
          <IconButton
            color="primary"
            onClick={() => {
              setEdit(true);
            }}
          >
            <img src={Edit} alt="" />
          </IconButton>
        </Grid>
        <Grid
          item
          container
          xs={12}
          className={border.border}
          style={{ height: "calc(100% - 50px)", margin: 8 }}
        >
          {/* Personal Info Right Section */}
          <Grid item xs={6} style={{}} container justifyContent="space-between">
            <Grid item xs={5}>
              {list1.map((item, i) => (
                <Typography
                  key={i}
                  variant="body2"
                  style={{ padding: "8px", height: 50 }}
                >
                  {item.title} :
                </Typography>
              ))}
            </Grid>
            <Grid item xs={6}>
              {list1.map((item, i) => (
                <Typography
                  key={i}
                  variant="body2"
                  style={{ padding: "8px", height: 50 }}
                >
                  {profile !== undefined
                    ? item.name === "default_page_link"
                      ? default_page
                        ? default_page.title
                        : ""
                      : profile[item.name]
                    : clear()}
                </Typography>
              ))}
            </Grid>
          </Grid>
          {/* Personal Info Right Section */}
          <Grid item xs={6} style={{}} container>
            <Grid item xs={6}>
              {list2.map((item, i) => (
                <Typography
                  key={i}
                  variant="body2"
                  style={{ padding: "8px", height: 50 }}
                >
                  {item.title} :
                </Typography>
              ))}
            </Grid>
            <Grid item xs={6}>
              {list2.map((item, i) => (
                <Typography
                  key={i}
                  variant="body2"
                  style={{ padding: "8px", height: 50 }}
                >
                  {profile !== undefined
                    ? item.name === "cDate"
                      ? utils.today(new Date(profile["cDate"]))
                      : profile[item.name]
                    : clear()}
                </Typography>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fade>
  );
};

export default PersonalInfo;

const list1 = [
  { title: "شماره موبایل", name: "cellphone" },
  { title: "ایمیل", name: "email" },
  { title: "نام", name: "first_name" },
  { title: "نام خوانوادگی", name: "last_name" },
  { title: "کد ملی", name: "ssn" },
  { title: "رمز عبور", name: "" },
  { title: "گروه کاربری", name: "role" },
  { title: "صفحه پیش فرض", name: "default_page_link" },
];
const list2 = [
  { title: "تاریخ عضویت", name: "cDate" },
  { title: "وضعیت", name: "last_state" },
];
